import { ProgramPhases } from "./ProgramPhases";
import { useProgram } from "../../hooks/useProgram";
import { useFetchUserPhaseActions } from "@platform/hooks/useFetchUserPhaseActions";

export function ProgramPhasesContainer() {
  const { currentPhase, phases } = useProgram();

  const { isLoading } = useFetchUserPhaseActions();

  return (
    <ProgramPhases
      currentPhase={currentPhase}
      phases={phases}
      isLoading={isLoading}
    />
  );
}

export default ProgramPhasesContainer;
